<template>
  <div id="detalleSolicitudComprobacionAMEX" :data-ready="printReady">
    <v-toolbar>
      <img src="@/assets/logo_javer.png" height="60" width="auto">
      <v-spacer></v-spacer>
      <v-toolbar-title>Detalle de solicitud de comprobación de gastos AMEX</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6>
            <v-container>
              <v-select v-model="solicitud.estado_cuenta" :items="estados_cuenta"
                :item-text="item => `${item.tarjetahabiente} - ${item.periodo}`" item-value="idestado_cuenta_amex"
                label="Estados de cuenta" disabled />
              <br />
              <v-text-field v-model="solicitud.tipo_solicitud" label="Tipo de solicitud" disabled></v-text-field>
              <v-flex xs12 sm12 md6>
                <v-select v-model="solicitud.tipo_pago" :items="tipos_pago" :disabled="true"
                  label="Tipo de Pago"></v-select>
              </v-flex>
              <br />
              <h3 class="grey--text">FIRMAS</h3><br />
              <v-list three-line>
                <template v-for="(item, i) in firmas">
                  <v-list-tile class="pb-2 pt-2">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                      <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                        v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                </template>
              </v-list>
            </v-container>
          </v-flex>
          <v-flex xs6>
            <v-container>
              <h3 class="grey--text">Resumen del estado de cuenta seleccionado</h3>
              <br />
              <v-data-table :headers="headersEC" :items="estado_cuenta_seleccionado" :loading="loading"
                class="elevation-1" hide-actions>
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="{ item }">
                  <tr>
                    <td class="text-xs-center">{{ item.tarjetahabiente }}
                    </td>
                    <td class="text-xs-center">{{ formatDateShort(item.fecha_corte)
                      }}
                    </td>
                    <td class="text-xs-center">{{ formatDateShort(item.fecha_pago)
                      }}
                    </td>
                    <td class="text-xs-center">{{ formatCurrency(item.saldo_a_pagar) }}</td>
                  </tr>
                </template>
                <template slot="no-data">
                  <div class="text-xs-center">No se ha seleccionado estado de cuenta.</div>
                </template>
              </v-data-table>
              <br />
              <br />
              <h3 class="grey--text">COMPROBANTES</h3><br />
              <v-text-field v-model="solicitud.comprobantes.no_comprobantes" class="pt-3" label="No. Comprobantes" box
                readonly></v-text-field>
              <v-text-field v-model="solicitud.comprobantes.subtotal" label="Subtotal" prefix="$" suffix="MXN" box
                readonly></v-text-field>
              <v-text-field v-model="solicitud.comprobantes.iva" label="IVA" prefix="$" suffix="MXN" box
                readonly></v-text-field>
              <v-text-field v-model="solicitud.comprobantes.importe_total" label="Importe por reembolsar" prefix="$"
                suffix="MXN" box readonly></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import services from '@/config/services'
import axios from 'axios'
import printReady from '@/utils/printReady'

export default {
  name: 'detalleSolicitudComprobacionAMEX',
  mixins: [printReady],
  data: () => ({
    tipos_pago: ['Transferencia', 'Cheque'],
    estados_cuenta: [],
    estado_cuenta_seleccionado: [],
    firmas: null,
    solicitud: {
      tipo_solicitud: 'Comprobación AMEX',
      tipo_pago: null,
      comprobantes: {
        importe_total: 0,
        no_comprobantes: 0,
        descuento: 0,
        subtotal: 0,
        iva: 0,
        nueva: {
          tipo_gasto: "deducible",
          pdf: { nombre: "", data: null },
          xml: { nombre: "", data: null },
          centro: null,
          concepto: "",
          rfc: "",
          proveedor: "",
          folio: "",
          uuid: "",
          no_comprobante: "",
          fecha_timbrado: "",
          subtotal: "",
          descuento: "",
          iva: "",
          total: ""
        },
        detalle: []
      }
    },
    headersEC: [
      {
        text: "Tarjetahabiente",
        value: "tarjetahabiente",
        sortable: false,
        class: "text-xs-center"
      },
      {
        text: "Fecha Corte",
        value: "fecha_corte",
        sortable: false,
        class: "text-xs-center"
      },
      {
        text: "Fecha Pago",
        value: "fecha_pago",
        sortable: false,
        class: "text-xs-center"
      },
      {
        text: "Saldo a pagar",
        value: "saldo_a_pagar",
        sortable: false,
        class: "text-xs-center"
      },
    ],
    loading: false,
  }),
  mounted() {
    this.fetchSolicitudes()
  },
  methods: {
    calcularTotales() {
      let subtotal = 0.0
      let descuento = 0.0
      let iva = 0.0
      let total = 0.0
      for (let i = 0; i < this.solicitud.comprobantes.detalle.length; i++) {
        subtotal += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].subtotal).toFixed(
            2
          )
        );
        descuento += parseFloat(
          parseFloat(
            this.solicitud.comprobantes.detalle[i].descuento
          ).toFixed(2)
        );
        iva += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].iva).toFixed(2)
        );
        total += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].total).toFixed(2)
        );
      }

      this.solicitud.comprobantes.subtotal = subtotal.toFixed(2);
      this.solicitud.comprobantes.iva = iva.toFixed(2);
      this.solicitud.comprobantes.descuento = descuento.toFixed(2);
      this.solicitud.comprobantes.importe_total = total.toFixed(2);
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    async fetchSolicitudes() {
      this.loading = true;
      try {
        let idsolicitud_amex = this.$route.query.idsolicitud_amex;
        let idsolicitud_comprobacion_amex = this.$route.query.idsolicitud_comprobacion_amex;
        var token = this.$route.query.token
        this.$session.start()
        this.$session.set('jwt', token)
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.amexSolicitudesDetalle.replace(
          ":idsolicitud_amex",
          idsolicitud_amex
        );
        const { data } = await axios.get(url, { headers });
        this.detalleSolicitudAmex = data
        const estadosCuenta = data.estados_cuenta;
        const solicitudesComprobacion = data.solicitudes_comprobacion_amex;
        const solicitud = solicitudesComprobacion.find(sc => sc.idsolicitud_comprobacion_amex == idsolicitud_comprobacion_amex);
        this.firmas = solicitud.firmas
        let estadoCuentaAsociado = estadosCuenta.find(ec => ec.idestado_cuenta_amex === solicitud.idestado_cuenta_amex);
        this.estados_cuenta = [estadoCuentaAsociado]
        this.solicitud.estado_cuenta = estadoCuentaAsociado
        this.estado_cuenta_seleccionado = [estadoCuentaAsociado]
        this.solicitud.comprobantes.detalle = []
        this.solicitud.tipo_pago = solicitud.tipo_pago
        for (let c of solicitud.comprobantes_amex) {
          this.solicitud.comprobantes.detalle.push({
            id: c.idcomprobante_amex,
            tipo_gasto: c.tipo_gasto,
            concepto: c.idcat_concepto.idcat_concepto_sat,
            fecha_timbrado: c.fecha_timbrado,
            subtotal: c.subtotal,
            iva: c.iva,
            descuento: c.descuento,
            total: c.total,
            uuid: c.uuid,
            xml: { data: c.idcomprobante_amex },
            pdf: { data: c.idcomprobante_amex },
            data: c,
          })
        }
        this.solicitud.comprobantes.no_comprobantes = solicitud.comprobantes_amex.length;
        this.calcularTotales()
        this.markPrintReady();
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {

        this.loading = false;
      }
    },
  }
}
</script>
